import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldOff, ArrowRight } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

// Global paywall modal — listens for 402 responses dispatched by the axios
// interceptor and pops up with a clear "Subscribe" CTA. Stops the user from
// trying to bypass the trial gate by hammering buttons after exhaustion.
export function PaywallModal() {
    const [open, setOpen] = useState(false);
    const [detail, setDetail] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const handler = (e) => {
            const d = (e.detail && e.detail.detail) || 'Start your 7-day free trial to keep using QuotesFlow.';
            setDetail(d);
            setOpen(true);
        };
        window.addEventListener('qf:paywall', handler);
        return () => window.removeEventListener('qf:paywall', handler);
    }, []);

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent data-testid="paywall-modal">
                <DialogHeader>
                    <div className="mx-auto h-12 w-12 rounded-full bg-amber-50 flex items-center justify-center mb-1">
                        <ShieldOff className="h-6 w-6 text-amber-700" />
                    </div>
                    <DialogTitle className="font-display text-center text-xl">Start your 7-day free trial</DialogTitle>
                    <DialogDescription className="text-center text-slate-600">
                        {detail}
                    </DialogDescription>
                </DialogHeader>
                <div className="rounded-lg bg-slate-50 border border-slate-200 p-3 text-sm text-slate-700 space-y-1">
                    <div className="font-medium text-slate-900">Every plan includes a 7-day free trial:</div>
                    <ul className="list-disc pl-5 space-y-0.5 text-slate-600">
                        <li>No charge for 7 days — cancel anytime before then</li>
                        <li>Card required upfront (auto-charges on day 8 unless canceled)</li>
                        <li>Full access to lead lookups, AI estimates, quotes &amp; PDF e-sign</li>
                    </ul>
                </div>
                <DialogFooter className="flex-col gap-2 sm:flex-row sm:gap-2">
                    <Button variant="outline" onClick={() => setOpen(false)} data-testid="paywall-dismiss">Not now</Button>
                    <Button
                        onClick={() => { setOpen(false); navigate('/pricing'); }}
                        className="bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold"
                        data-testid="paywall-see-pricing"
                    >
                        Start free trial <ArrowRight className="h-4 w-4 ml-1" />
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export function firePaywall(detail) {
    window.dispatchEvent(new CustomEvent('qf:paywall', { detail: { detail } }));
}
